export const scrollBarStyle = {
  "&::-webkit-scrollbar": {
    width: "6px",
    height: "6px",
    borderRadius: "8px",
    backgroundColor: `rgba(0, 0, 0, 0.05)`,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: `rgba(0, 0, 0, 0.05)`,
  },
};
export const trim = (str) => {
  return str?.length > 25 ? str.substring(0, 25) + "..." : str;
};

export const useLogOut = () => {
  return () => {
    localStorage.clear();
    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
  };
};

export const formatDate = (date, fallback = "") => {
  if (!date) return fallback;

  return new Date(date).toLocaleDateString("default", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatDateTime = (date, fallback = "") => {
  if (!date) return fallback;

  return new Date(date).toLocaleString("default", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

export const day = new Date().toLocaleDateString("default", {
  day: "numeric",
  month: "short",
  year: "numeric",
});

export const month = new Date().toLocaleString("default", { month: "long" });
